import useClient from 'hooks/swr/useClient';
import CardedPage from 'layout/pages/CardedPage';
import { isNil, toNumber } from 'lodash';
import { type FC } from 'react';
import { useParams } from 'react-router-dom';
import ClientView from '../../components/ClientView';
import ClientPageSkeleton from './ClientPageSkeleton';
import ClientViewPageHeader from './ClientViewPageHeader';

const ClientViewPage: FC = () => {
  const { clientId } = useParams();
  const { data: client, isLoading } = useClient(toNumber(clientId));

  if (isLoading || isNil(client)) {
    return (
      <CardedPage title='Клиент' header={<ClientViewPageHeader />}>
        <ClientPageSkeleton />
      </CardedPage>
    );
  }

  return (
    <CardedPage
      title='Клиент'
      disablePadding
      header={<ClientViewPageHeader client={client} />}>
      <ClientView client={client} />
    </CardedPage>
  );
};

export default ClientViewPage;
